module.exports = __webpack_public_path__ + "static/media/wortel.3103bd9f.jpeg";